//live server
/*let BASEURL = 'http://ec2-13-229-128-63.ap-southeast-1.compute.amazonaws.com';
let PORT = ':8000';*/

//live server 2
/*
let BASEURL = 'https://bdnbd.tk';
*/

//kakan's pc
let BASEURL = 'http://192.168.1.31';
let PORT = ':8008';

//my pc
/*let BASEURL = 'http://192.168.1.23';
let PORT = ':8000';*/


let VERSION = '/api/v1';

var getAccessToken =  function () {
  let auth = JSON.parse(localStorage.getItem('auth-response'));
  if (auth){
    return 'Bearer '+auth.access_token;
  }else{
    return '';
  }
};

let routes = {
  login: BASEURL + PORT + '/oauth/token',
  register: BASEURL + PORT + VERSION + '/users',
  loggeduser: BASEURL + PORT + VERSION + '/logged_user',
  donors: BASEURL + PORT + VERSION + '/blood_donors_all',
  postDonor:'/blood_donor',
  blood_donors: BASEURL + PORT + VERSION + '/blood_donors/',
  blood_donors_with_blood_group: BASEURL + PORT + VERSION + '/blood_donors',
  blood_donations: '/blood_donations',
  requstList:BASEURL + PORT + VERSION + '/all_blooddonor_search_request',
  requestFeedList:BASEURL + PORT + VERSION + '/blood_request_posts',
  finderList:BASEURL + PORT + VERSION +'/finders',
  bloodGroup:BASEURL + PORT + VERSION +'/blood_groups',
  gender:BASEURL + PORT + VERSION +'/genders',
  profile:'/profile',
  url: BASEURL + PORT + VERSION,
  contact_us: BASEURL + PORT + VERSION + '/create_feedback',
  feed_back: BASEURL + PORT  + VERSION + '/feedbacks'
};
/*let routes = {
  login: BASEURL + '/oauth/token',
  register: BASEURL + VERSION + '/users',
  loggeduser: BASEURL + VERSION + '/logged_user',
  donors: BASEURL + VERSION + '/blood_donors_all',
  postDonor:'/blood_donor',
  blood_donors: BASEURL + VERSION + '/blood_donors/',
  blood_donors_with_blood_group: BASEURL + VERSION + '/blood_donors',
  blood_donations: '/blood_donations',
  requstList:BASEURL + VERSION + '/all_blooddonor_search_request',
  requestFeedList:BASEURL + VERSION + '/blood_request_posts',
  finderList:BASEURL + VERSION +'/finders',
  bloodGroup:BASEURL + VERSION +'/blood_groups',
  gender:BASEURL + VERSION +'/genders',
  profile:'/profile',
  url: BASEURL + VERSION,
  contact_us: BASEURL + VERSION + '/create_feedback'
};*/

let headers = function () {

  let basic = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  }

  let authheader = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "Authorization" : getAccessToken()
  }

  let imageHeader = {
    "Authorization" : getAccessToken()
  };

  return {basic, authheader, imageHeader};
};

export default {routes, headers, BASEURL,PORT, VERSION};
